<template>
  <Dialog
    width="752px"
    :visible="renderData.visible"
    :backgroundImage="false"
    @close="onClose"
    :title="$$t('editor.feedback')"
    mobileRenderType="drawerDialog"
    titleAlign="left"
    :customClass="`feedback-popup-dialog feedback-popup-dialog--${createRenderType}`"
  >
    <div
      class="feedback-popup-dialog-content"
      :class="{
        'feedback-popup-dialog-content-mobile': createRenderType == 'mobile',
        'feedback-popup-dialog-content-song': props.hideType,
      }"
    >
      <div
        class="feedback-popup-dialog-type"
        v-if="!props.hideType"
        :class="{
          'feedback-popup-dialog-type-disabled': props.disabledType,
        }"
      >
        <template v-for="item in categoryList" :key="item">
          <div class="feedback-popup-dialog-type-item-box fn-inline">
            <div
              class="feedback-popup-dialog-type-item flex-row-center pointer"
              :class="{
                active: renderData.type == item.value,
              }"
              @click="
                () => {
                  if (!props.disabledType) {
                    renderData.type = item.value;
                  }
                }
              "
            >
              <i></i>{{ item.label }}
            </div>
          </div>
        </template>
        
      </div>
      <div class="feedback-popup-dialog-description">
        <textarea
          ref="refDescriptionInput"
          v-model="renderData.description"
          :placeholder="$$t('editor.feedback_decription_placeholder')"
          @input="handleDescriptionInput"
          @change="handleDescriptionChange"
        ></textarea>
        <div
          class="feedback-popup-dialog-description-count"
          :class="{
            error: renderData.description.length >= MAX_DISCRIPTION_COUNT,
          }"
        >
          {{ renderData.description.length }} / {{ MAX_DISCRIPTION_COUNT }}
        </div>
      </div>
      <div
        class="feedback-popup-dialog-link" v-if="!props.hideType && !props.item" :class="{
          // 'feedback-popup-dialog-link-disabled': props.hideType
        }"
        >
        <div class="feedback-popup-dialog-link-placeholder" 
        :class="{
          'olh': createRenderType != 'mobile',
          'omlh-3': createRenderType == 'mobile'
        }" 
        v-if="!props.hideType && !renderData.link">
          <span class="fn-inline">
             {{ $$t("editor.feedback_link_placeholder").split('[[icon]]')[0] }}
          </span>
          <i class="fn-inline icon icon-share"></i>  
          <span class="fn-inline flex1">
            {{ $$t("editor.feedback_link_placeholder").split('[[icon]]')[1] }}
          </span>
        </div>
        <input
          v-if="createRenderType != 'mobile'"
          v-model="renderData.link"
          :readonly="props.hideType"
          placeholder=""
          @input="handleLinkInput"
          @change="handleLinkChange"
        ></input>
        <textarea
           v-if="createRenderType == 'mobile'"
          v-model="renderData.link"
          :readonly="props.hideType"
          placeholder=""
          @input="handleLinkInput"
          @change="handleLinkChange"
        ></textarea>
        <div
          class="feedback-popup-dialog-description-count"
          :class="{
            error: renderData.link.length >= MAX_LINK_COUNT,
          }"
        >
          {{ renderData.link.length }} / {{ MAX_LINK_COUNT }}
        </div>
      </div>
      <div class="feedback-popup-dialog-song"  v-if="props.hideType && props.item">
        <AudioItem
          :item="props.item"
          :pitem="props.pitem"
        >
        </AudioItem>
        <div class="feedback-popup-dialog-song-mask">
        </div>
      </div>
      <div
        class="feedback-popup-dialog-file flex"
        :class="{
          'feedback-popup-dialog-file-active':
            renderData.renderDataFiles?.length|| createRenderType != 'mobile'
        }"
      >
        <div
          class="upload-image flex pointer"
          :class="{
            'upload-image-disabled':
              renderData.renderDataFiles?.length >= MAX_FILE_COUNT,
          }"
        >
          <file-pond
            ref="refUpload"
            v-if="renderData.ifRenderFilePond"
            label-idle=""
            v-bind:allow-multiple="true"
            :acceptedFileTypes="renderData.acceptedFileTypes.join(',')"
            @addfile="handleAddFile"
            v-bind:files="renderData.files"
          >
          </file-pond>
          <div
            class="upload-image-content flex-row-center"
            @click="onAddFileButtonClick"
          >
            <i class="upload-image-icon block"> </i>
            <span class="upload-image-text block">
              {{ $$t("editor.upload_images") }}
            </span>
          </div>
        </div>
        <div class="feedback-popup-dialog-files-box">
          <template
            v-for="(item, index) in renderData.renderDataFiles"
            :key="item"
          >
            <div class="feedback-popup-dialog-file-item fn-inline">
              <img :src="item.url" />
              <div class="feedback-popup-dialog-file-item-delete flex">
                <IconButton
                  v-if="item.state != 2"
                  size="24px"
                  icoSize="16px"
                  backgroundColor="rgb(255, 255, 255, 0.1)"
                  hoverBackgroundColor="rgb(255, 255, 255, 0.2)"
                  @onClick="
                    () => {
                      handleRemoveFile(item, index);
                    }
                  "
                >
                  <img src="@/assets/img/close-ico.png" />
                </IconButton>
                <IconButton
                  v-if="item.state == 2"
                  size="24px"
                  icoSize="16px"
                  backgroundColor="rgb(255, 255, 255, 0.1)"
                  hoverBackgroundColor="rgb(255, 255, 255, 0.2)"
                  @onClick="
                    () => {
                      handleRemoveFile(item, index);
                    }
                  "
                >
                  <img src="@/assets/img/close-ico.png" />
                </IconButton>
              </div>
              <div
                class="feedback-popup-dialog-file-item-uploading flex-center"
              >
                <i
                  class="loading block rotate-loading"
                  v-if="item.state == 1"
                ></i>

                <i
                  class="error-retry block pointer"
                  v-if="item.state == 2"
                  @click="handleRetryUpload(item)"
                ></i>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="feedback-popup-dialog-btns">
        <Button
          @click="doSave"
          :disabled="renderData.disabledSubmit"
          :renderStyle="{
            '--padding': '0',
            '--width': '100%',
            '--height': '48px',
            '--borderRadius': '48px',
            '--background':
              'linear-gradient(97deg, rgba(79, 222, 255, 1) 0%, rgba(230, 117, 255, 1) 99%)',
            '--fontColor': '#fff',
            '--fontSize': '16px',
            '--fontWeight': '500',
            '--border': 'none',
            '--backgroundHover':
              'linear-gradient(97deg, rgba(79, 222, 255, 0.75) 0%, rgba(230, 117, 255, 0.75) 99%)',
            '--fontColorHover': '#fff',
          }"
        >
          {{ $$t("editor.send") }}
        </Button>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
  getCurrentInstance,
} from "vue";
import Dialog from "@/components/basic/dialog/Dialog.vue";
import IconButton from "@/components/basic/button/IconButton.vue";
import AudioItem from "@/page/create/feedList/audioItem.vue";

import globalConfig, {
  chinaAppName,
  ModuleOpenStateControl,
  getPipeReadableFlowUrl,
} from "@/config/config.js";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";

import objectStorage, {
  getObjectStorageFullUrl,
} from "@/lib/objectStorage/objectStorage.js";
import apiCommon from "@/api/api/apiCommon.js";

const createLayoutStore = useCreateLayoutStore();
import useUserDataStore from "@/store/userDataStore";
const userDataStore = useUserDataStore();
const { createRenderType } = storeToRefs(createLayoutStore);
import Button from "@/components/basic/button/Button.vue";
import message from "@/components/functionCallComponent/message.jsx";

import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
const { $$language, $$t, $$tm, $$tValue } = getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {}
const globalProperties =
  getCurrentInstance()?.appContext.config.globalProperties;

const FilePond = vueFilePond();

const MAX_DISCRIPTION_COUNT = 2000;
const MAX_LINK_COUNT = 500;
const MAX_FILE_COUNT = 8;

const acceptedFileTypes = [
  "image/png",
  "image/jpeg",
  "image/jpg",
  "image/webp",
];

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  type: {
    type: Number,
    default: 1,
  },
  hideType: {
    type: Boolean,
    default: false,
  },
  disabledType: {
    type: Boolean,
    default: false,
  },
  item: {
    type: Object,
    default: () => {},
  },
  pitem: {
    type: Object,
    default: () => {},
  },
});

const emits = defineEmits(["update:visible", "report"]);

const getCategoryList = () => {
  return [
    {
      label: $$t("editor.feedback_type_option_create"),
      value: 1,
    },
    {
      label: $$t("editor.feedback_type_option_subscribe"),
      value: 2,
    },
    // {
    //   label: $$t("editor.feedback_type_option_api"),
    //   value: 3,
    // },
  ];
};

const refUpload = ref(null);
const refDescriptionInput = ref(null);

const renderData = reactive({
  visible: props.visible,
  ifRenderFilePond: true,
  files: [],
  file: null,
  acceptedFileTypes: acceptedFileTypes,
  description: "",
  type: props.type,
  link: "",
  renderDataFiles: [],
  disabledSubmit: true,
});
const categoryList = ref(getCategoryList());

const checkMediaType = (file) => {
  if (file.type.toLocaleLowerCase().startsWith("image")) {
    return acceptedFileTypes.includes(file.type.toLocaleLowerCase())
      ? "image"
      : "unknown";
  } else {
    return "unknown";
  }
};

const onClose = () => {
  renderData.visible = false;
};

const handleDescriptionInput = (e) => {
  e.target.value = e.target.value.slice(0, MAX_DISCRIPTION_COUNT);
  renderData.description = e.target.value;
};

const handleDescriptionChange = (val) => {};

const handleLinkInput = (e) => {
  e.target.value = e.target.value.slice(0, MAX_LINK_COUNT);
  renderData.link = e.target.value;
};
const handleLinkChange = (val) => {};

const handleRemoveFile = (item, index) => {
  renderData.renderDataFiles.splice(index, 1);
};

const onAddFileButtonClick = () => {
  refUpload.value?.$el.querySelector(".filepond--drop-label").dispatchEvent(
    new MouseEvent("click", {
      bubbles: true,
      cancelable: true,
      view: window,
    })
  );
};

const handleAddFile = (error, fileItem, fileList) => {
  if (renderData.renderDataFiles.length >= MAX_FILE_COUNT) {
    return;
  }
  if (error) {
    console.error("File add error:", error);
    return;
  }
  if (checkMediaType(fileItem.file) != "image") {
    message.error({
      position: "center",
      content: $$t("editor.select_image"),
    });
  }
  if (fileItem.file.size > 10 * 1024 * 1024) {
    message.error({
      position: "center",
      content: $$t("editor.upload_file_size_limit"),
    });
    return;
  }
  doAddFile(fileItem.file);
};

const doAddFile = async (file) => {
  let obj = {
    file: file,
    pathKey: "",
    url: (window.URL || window.webkitURL).createObjectURL(file),
    name: file.name,
    state: 1,
  };
  renderData.renderDataFiles.push(obj);
  doUploadFile(
    file,
    (objectStorageRes) => {
      obj.pathKey = objectStorageRes.pathKey;
      obj.url = getObjectStorageFullUrl(objectStorageRes.pathKey);
      obj.file = null;
      obj.state = 3;
      renderData.renderDataFiles = [].concat(renderData.renderDataFiles);
    },
    () => {
      obj.state = 2;
      renderData.renderDataFiles = [].concat(renderData.renderDataFiles);
    }
  );
};

const handleRetryUpload = (item) => {
  item.state = 1;
  renderData.renderDataFiles = [].concat(renderData.renderDataFiles);
  doUploadFile(
    item.file,
    (objectStorageRes) => {
      item.pathKey = objectStorageRes.pathKey;
      item.url = getObjectStorageFullUrl(objectStorageRes.pathKey);
      item.file = null;
      item.state = 3;
      renderData.renderDataFiles = [].concat(renderData.renderDataFiles);
    },
    () => {
      item.state = 2;
      renderData.renderDataFiles = [].concat(renderData.renderDataFiles);
    }
  );
};

const doUploadFile = async (file, successCallback, errorCallback) => {
  try {
    const objectStorageRes = await objectStorage.uploadFileToObjectStorage(
      file,
      (obj) => {
        renderData.uploadCallbackData = obj;
      }
    );
    if (objectStorageRes) {
      successCallback(objectStorageRes);
    } else {
      errorCallback();
    }
  } catch (error) {
    errorCallback();
  }
};

const initUploadContent = () => {
  if (refUpload.value) {
    setTimeout(() => {
      refUpload.value?.$el
        ?.querySelector("input")
        ?.setAttribute("accept", renderData.acceptedFileTypes.join(","));
    }, 20);
  }
};

const doSave = async () => {
  let saveData = {
    category: renderData.type,
    content: renderData.description,
    url: renderData.link,
    images: renderData.renderDataFiles
      ?.filter((item) => {
        return item.state == 3;
      })
      .map((item) => {
        return item.pathKey;
      }),
  };
  const globalProperties = (
    getCurrentInstance() || window?.$getVueCurrentInstance?.()
  ).appContext.config.globalProperties

  globalProperties?.logClickEvent("feedback_send", {
    tab_stare: props.hideType ? 'song' : 'global',
    source: !props.hideType ? renderData.type==1 ? 'create_music' : 'subscription&credits' : null,
    content_id: props.hideType ? props.item?.song_id  : null,
    details: renderData.description,
  })
 
  if (!renderData.description) {
    message.error({
      position: "top",
      content: $$t("editor.feedback_description_empty"),
    });
    refDescriptionInput.value?.focus();
    return;
  }
  apiCommon
    .sendFeedback(saveData)
    .then((res) => {
      if (res.code == 200) {
        message.success({
          position: "top",
          content: $$t("editor.send_feedback_success"),
        });
        renderData.visible = false;
        emits("report", saveData);
      } else {
        if(res.code == 6355){
          message.error({
            position: "top",
            content: $$t("editor.feedback_link_error"),
          });
        } else {
          message.error({
            position: "top",
            content: $$t("editor.send_feedback_fail"),
          });
        }
      }
    }).catch((err) => {
      message.error({
        position: "top",
        content: $$t("editor.send_feedback_fail"),
      });
    })
};

watch(
  () => props.visible,
  (val) => {
    renderData.visible = props.visible;
  }
);

watch(
  () => renderData.visible,
  (val) => {
    emits("update:visible", val);
  }
);

watch(
  () => userDataStore.appLanguage,
  (val) => {
    nextTick().then(() => {
      categoryList.value = getCategoryList();
    });
  }
);

watch(
  () => renderData.description,
  (val) => {
    if (val.length < 1) {
      renderData.disabledSubmit = true;
    } else {
      renderData.disabledSubmit = false;
    }
  }
);

onMounted(() => {
  initUploadContent();
  if(props.hideType){
    renderData.link=`${globalConfig.baseOrigin}${($$lanuage() == 'en' || globalConfig.appname == chinaAppName) ? '' : `/${$$lanuage()}`}/song-detail/${props.item?.share_key}`
  }
});
</script>

<style lang="scss">
.feedback-popup-dialog {
  .feedback-popup-dialog-content {
    padding: 0 40px 40px;
  }
  &--mobile {
    .feedback-popup-dialog-content {
      padding: 0 16px 16px;
    }
  }
}
.feedback-popup-dialog-content {
  --filepond-border-radius: 8px;
  --filepond-min-height: 0;

  .feedback-popup-dialog-type {
    color: #fff;
    margin-top: 20px;
    .feedback-popup-dialog-type-item-box{
      margin-right: 16px;
    }
    .feedback-popup-dialog-type-item {
      
      &:last-child {
        margin-right: 0;
      }
      i {
        display: inline-block;
        width: 18px;
        height: 18px;
        background-image: url("@/assets/img/credit/ic-select.png");
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100% 100%;
        margin-right: 8px;
      }
      &.active {
        // color: #fff;
        i {
          background-image: url("@/assets/img/icon-selected.png");
        }
      }
    }
    &.feedback-popup-dialog-type-disabled {
      poninter-events: none;
    }
  }
  .feedback-popup-dialog-description {
    height: 188px;
    margin: 20px 0 0 0;
    position: relative;
    textarea {
      height: 100%;
      width: 100%;
      padding: 16px 16px 44px 16px;
      border: none;
      outline: none;
      background: transparent;
      font-family: HarmonyOS Sans SC;
      font-size: 16px;
      font-weight: normal;
      line-height: 24px;
      color: #ffffff;
      border-radius: 8px;
      flex-direction: column;
      background: rgba(255, 255, 255, 0.1);
      resize: none;
      &::placeholder {
        color: rgba(255, 255, 255, 0.5) !important;
      }

      &:focus {
        border: 1px solid #94adff;
        padding: 15px 15px 43px 15px;
      }
    }
    .feedback-popup-dialog-description-count {
      font-family: HarmonyOS Sans SC;
      font-size: 12px;
      font-weight: normal;
      line-height: 16px;
      text-align: right;
      color: rgba(255, 255, 255, 0.3);
      position: absolute;
      bottom: 16px;
      right: 16px;
      pointer-events: none;
      &.error {
        color: #ff5f74;
      }
    }
  }
  .feedback-popup-dialog-song{
    position: relative;
    margin: 8px 0 8px 0;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    opacity: 0.5;
    .audio-item-play-status{
      display: none;
    }
    .audio-item-wave-box{
      display: none;
    }
    .audio-item-info-op-box{
      display: none;
      
    }
    .audio-item-cover-op{
      display: none!important;
    }
    .audio-item-cover-op-bg{
      *{
        display: none!important;
      }
    }
    .audio-item{
      padding: 12px 12px 12px 12px;
      poninter-events: none;
    }
    .feedback-popup-dialog-song-mask{
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }

  .feedback-popup-dialog-link {
    height: 60px;
    position: relative;
    margin: 8px 0 8px 0;
    .feedback-popup-dialog-link-placeholder {
      position: absolute;
      height: 100%;
      width: 100%;
      padding: 18px 80px 18px 16px;
      background: transparent;
      font-family: HarmonyOS Sans SC;
      font-size: 16px;
      font-weight: normal;
      line-height: 24px;
      color: #ffffff;
      border-radius: 8px;
      flex-direction: row;
      opacity: 0.5;
      align-items: center;
      i{
         height: 20px;
         width: 20px;
         background: url(/src/assets/img/share-ico.png);
         background-size: 100% 100%;
         margin: 0 4px;
      }
      .flex1{
        flex: 1 1 auto;
        min-width: 0;
      }
    }
    input,textarea {
      position: absolute;
      height: 100%;
      width: 100%;
      padding: 18px 80px 18px 16px;
      border: none;
      outline: none;
      background: transparent;
      font-family: HarmonyOS Sans SC;
      font-size: 16px;
      font-weight: normal;
      line-height: 24px;
      color: #ffffff;
      border-radius: 8px;
      flex-direction: column;
      background: rgba(255, 255, 255, 0.1);
      resize: none;
      &::placeholder {
        color: rgba(255, 255, 255, 0.5) !important;
      }

      &:focus {
        border: 1px solid #94adff;
        padding: 23px 79px 23px 15px;
      }
    }
    .feedback-popup-dialog-description-count {
      font-family: HarmonyOS Sans SC;
      font-size: 12px;
      font-weight: normal;
      line-height: 24px;
      text-align: right;
      color: rgba(255, 255, 255, 0.3);
      position: absolute;
      bottom: 50%;
      right: 16px;
      transform: translateY(50%);
      pointer-events: none;
      &.error {
        color: #ff5f74;
      }
    }
    &.feedback-popup-dialog-link-disabled{
      pointer-events: none;
      opacity: 0.5;
      input,textarea{
        padding: 24px 16px 24px 16px;
      }
      .feedback-popup-dialog-description-count{
        display: none;
      }
    }
  }
  .feedback-popup-dialog-file {
    margin: 0 0 0 0;
    height: max-content;
    align-items: stretch;

    .upload-image {
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 12px 4px;
      background: rgba(255, 255, 255, 0.1);
      border-radius: 8px;
      min-height: 72px;
      width: 100%;
      min-width: 128px;
      margin: 0 0 8px 0;
      .upload-image-content {
        height: 100%;
        width: 100%;
        justify-content: center;
      }
      i {
        height: 20px;
        width: 20px;
        background: url(@/assets/img/upload-white-ico.png) no-repeat center;
        background-size: 100% 100%;
      }
      span {
        margin: 0 0 0 8px;
        font-family: HarmonyOS Sans SC;
        font-size: 14px;
        font-weight: 500;
        line-height: 14px;
        text-align: center;
        color: #ffffff;
      }
      &.upload-image-disabled {
        pointer-events: none;
        opacity: 0.5;
      }
    }
    &.feedback-popup-dialog-file-active {
      .upload-image {
        width: 128px;
        min-width: 128px;
        margin: 0 0 8px 0;
      }
      .upload-image-content{
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
      span{
        margin: 4px 0 0 0;
         font-size: 12px;
      }
    }
  }
  .feedback-popup-dialog-files-box {
    .feedback-popup-dialog-file-item {
      width: 128px;
      height: 72px;
      border-radius: 8px;
      margin: 0 0 8px 8px;
      position: relative;
      img {
        height: 100%;
        width: 100%;
        border-radius: 8px;
        object-fit: cover;
      }
      .feedback-popup-dialog-file-item-delete {
        padding: 8px;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.3);
        border-radius: 8px;
        justify-content: end;
        align-items: start;
      }
      .icon-button-box .icon-button {
        backdrop-filter: blur(8.33px);
      }
      .feedback-popup-dialog-file-item-uploading {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        i.loading {
          height: 20px;
          width: 20px;
          background: url(@/assets/img/loading-mini-white-3x.png) no-repeat
            center;
          background-size: 100% 100%;
        }
        i.error-retry {
          height: 20px;
          width: 20px;
          background: url(@/assets/img/warning.png) no-repeat center;
          background-size: 100% 100%;
        }
      }
    }
  }
  .feedback-popup-dialog-btns {
    margin: 12px 0 0 0;
    wwidth: 100%;
  }

  .filepond--root {
    height: max-content !important;
    min-height: var(--filepond-min-height) !important;
    background: transparent;
    box-shadow: none;
    align-items: center;
    justify-content: center;
    border-radius: var(--filepond-border-radius);
    margin: 0;
    contain: unset !important;
    line-height: 0;
    .filepond--wrapper {
      height: max-content !important;
      border-radius: var(--filepond-border-radius);
    }
    .filepond--browser.filepond--browser {
      display: none;
    }
    .filepond--list-scroller {
      display: none;
    }
    .filepond--credits {
      display: none;
    }

    .filepond--panel-root {
      border-radius: 0.5em;
      background: transparent;
      box-shadow: none;
      border-radius: max-content;
      display: none;
    }

    .filepond--assistant {
      display: none;
    }
    .filepond--drop-label {
      display: block;
      position: unset !important;
      visibility: visible !important;
      transform: translate3d(0px, 0, 0px) !important;
      height: max-content !important;
      border-radius: var(--filepond-border-radius) !important;
      min-height: var(--filepond-min-height) !important;
      opacity: 1 !important;
      pointer-events: auto !important;
      & > label {
        display: none;
      }
    }
    .filepond--data {
      display: none;
    }

    &[data-hopper-state="drag-over"] {
      .editor-audio-drag-upload-main {
        border: 1px dashed #94adff;
      }
    }
  }
  &.feedback-popup-dialog-content-song {
    .feedback-popup-dialog-btns {
      margin: 20px 0 0 0;
    }
  }
  &.feedback-popup-dialog-content-mobile {
    .feedback-popup-dialog-type {
      margin-top: 5px;
      .feedback-popup-dialog-type-item-box {
        margin-right: 8px;
      }
      .feedback-popup-dialog-type-item {
        padding: 0px 10px;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 40px;
        font-family: HarmonyOS Sans SC;
        font-size: 12px;
        font-weight: normal;
        line-height: 32px;
        color: #ffffff;
        min-width: max-content;
        &:last-child {
          margin-right: 0;
        }
        i {
          display: none;
        }
        &.active {
          background: #94adff;
          color: #000000;
        }
      }
    }
    .feedback-popup-dialog-description{
      textarea {
        padding: 12px 12px 40px 12px;
        font-size: 14px;
        &:focus {
          padding: 11px 11px 39px 11px;
        }
      }
      .feedback-popup-dialog-description-count{
        right: 12px;
        bottom: 12px;
      }
    }
    .feedback-popup-dialog-link {
      height: 100px;
      .feedback-popup-dialog-link-placeholder {
        padding: 12px 75px 12px 12px;
        font-size: 14px;
        i{
          height: 16px;
          min-width: 16px;
          margin: 0 2px;
        }
        span{
          max-width: 100%;
        }
      }
      textarea {
        padding: 12px 75px 12px 12px;
        font-size: 14px;
        &:focus {
          padding:  11px 74px 11px 11px;
        }
      }
      .feedback-popup-dialog-description-count{
        right: 12px;
      }
      &.feedback-popup-dialog-link-disabled{
        textarea{
          padding: 12px 12px 12px 12px;
        }
        .feedback-popup-dialog-description-count{
          display: none;
        }
      }
    }
    .feedback-popup-dialog-file {
      display: block;
      margin: 8px 0 20px 0;

      .upload-image {
        min-height: 48px;
        width: 100%;
      }
      .feedback-popup-dialog-files-box {
        margin-right: -8px;
      }
      .feedback-popup-dialog-file-item {
        margin: 0 8px 8px 0;
        height: 72px;
        width: calc(100% / 4 - 8px);
       //  max-width: 120px;
      }
      &.feedback-popup-dialog-file-active {
        margin: 8px 0 0 0;
        .upload-image {
          width: 100%;
        }
      }
    }
  }
}
</style>
